import RefreshIcon from "@mui/icons-material/Refresh";
import { Box, Link, Tooltip, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import EditIcon from "../../Pages/Person/EditIcon";
import {
  REACT_ADD_TIMESLOTS,
  REACT_UPDATE_TIMESLOT,
} from "../../actions/EndPoints";
import { ReactComponent as CreateIcon } from "../../assets/USA_Images/CreateIcon.svg";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import { getAllTimeSlots } from "../../slices/TimeSlot/TimeSlotSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import DeleteChecklist from "../Checklist/DeleteChecklist";
import FilterChecklistTemplate from "../ChecklistTemplateUSA/FilterChecklistTemplate";
import DeleteTimeSlot from "./DeleteTimeSlot";

export const TimeSlotList = () => {
  const [clear, setClear] = React.useState(false);
  const [totalRecords, setTotalRecords] = useState(1);
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const dispatch = useDispatch();
  const history = useHistory();
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [del, setDel] = useState(false);
  const [pageSize, setPageSize] = useState(0);
  const [openDeleteTimeSlot, setOpenDeleteTimeSlot] = useState(false);
  const [timeSlotId, setTimeSlotID] = useState();
  const [timeSlotName, setTimeSlotname] = useState();
  const { t } = useTranslation();
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);

  const [paging, setPaging] = useState({
    page: 1,
    rowsPerPage: 50,
  });

  const [filter, setFilter] = React.useState({
    name: "",
  });

  const defaultFilter = {
    name: "",
  };

  const handleChange = (newPage, size) => {
    setPage(newPage);
    setRowsPerPage(size);
    setPaging({
      page: newPage,
      rowsPerPage: size,
    });
  };

  useEffect(() => {
    loadData(filter, paging);
  }, [filter, paging, clear]);

  useEffect(() => {
    if (del === true && parseInt(pageSize) !== 1) {
      loadData(filter, { page: page, rowsPerPage: rowsPerPage });
      setDel(false);
    } else {
      if (del === true) {
        setPaging({ page: page - 1, rowsPerPage: rowsPerPage });
        setDel(false);
      }
    }
  }, [del]);

  const handleOpen = () => {
    setOpenEditDialog(true);
  };

  const handleClose = () => {
    setOpenEditDialog(false);
  };

  const resetFilter = () => {
    setClear(false);
    setPaging({ ...paging, page: 1 });
    setFilter(defaultFilter);
  };

  const handleTimeSlotDelete = (params) => {
    setOpenDeleteTimeSlot(!openDeleteTimeSlot);
    setTimeSlotID(params.id);
    setTimeSlotname(params.operationName);
    setDiaLogBoxBlur(true);
  };

  const loadData = (filter, paging) => {
    dispatch(getAllTimeSlots(Object.assign(filter, paging)))
      .unwrap()
      .then((data) => {
        if ((data.code = "DMSI0000" && data.data)) {
          setTotalRecords(data.data.totalCount);
          setPage(data.data.currentPage);
          setTotalPages(data.data.totalPages);
          setRows(data.data.timeZone);
          setPageSize(data.data.pageSize);
        } else {
          setRows([]);
        }
      })
      .catch((er) => { });
  };

  const handleFilter = (data) => {
    setClear(true);
    setPaging({ ...paging, page: 1 });
    setFilter({
      name: data.name,
    });
  };

  const columns = React.useMemo(() => [
    {
      headerName: "",
      sortable: false,
      width: 5,
      renderCell: (params) => {
        return <div></div>;
      },
    },

    {
      field: "operationName",
      headerName: t("accessLevelName"),
      flex: 1.8,
      width: 10,
      valueGetter: (params) => params.row.operationName,
      renderCell: (params) => (
        <Tooltip
          title={` ${params.row.operationName}`}
          placement="bottom-start"
        >
          {" "}
          <span>{params.row.operationName}</span>
        </Tooltip>
      ),
    },

    {
      field: "Actions",
      headerName: t("ACTION"),
      type: "actions",
      flex: 1,
      minWidth: 190,
      width: 150,
      renderCell: (params) => [
        <Box onClick={() => {
          history.push({
            pathname: REACT_UPDATE_TIMESLOT,
            state: { data: params.id },
          });
        }}>
          <EditIcon />
        </Box>,
        <Box onClick={() => handleTimeSlotDelete(params.row)}>
          <DeleteChecklist />
        </Box>,
      ],
    },
  ]);

  const getActions = (action, data) => {
    if (action === 0) {
      history.push({ pathname: REACT_UPDATE_TIMESLOT, state: { ...data } });
    } else if (action === 1) {
      // setOpen(!open);
    }
  };
  return (
    <>
      <Box>
        <Typography variant="h3" style={{ color: darkMode ? "#ffff" : "" }}>
          {t("ADD023")}
        </Typography>
      </Box>
      <Box style={{
        display: "flex",
        flexDirection: "row-reverse",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: "3px"
      }}>
        <Box item>
          {clear && (
            <Link
              href="#"
              underline="hover"
              className="line"
              style={{
                opacity: "0.8",
                color: "#E3393C",
                fontSize: "14px",
                underline: "hover",
                display: "inline",
              }}
              onClick={resetFilter}
            >
              {"Clear Filter"}
            </Link>
          )}
        </Box>
        <Tooltip title={t("ADD023")}>
          <Box
            item
            className={"addIcon"}
            onClick={() => {
              history.push({
                pathname: REACT_ADD_TIMESLOTS,
                state: {},
              });
            }}
          >
            <CreateIcon />
          </Box>
        </Tooltip>
        <Tooltip title={t("COMMON002")}>
          <Box item className="refreshIcon">
            <RefreshIcon onClick={() => loadData(filter, paging)} />
          </Box>
        </Tooltip>
        <Box item>
          <FilterChecklistTemplate
            rowsPerPage={rowsPerPage}
            applyFilter={(data) => handleFilter(data)}
          />
        </Box>
      </Box>
      <div style={{ height: 300, width: "100%", paddingTop: "10px" }}>
        <DataTableLatest
          columns={columns}
          rows={rows}
          page={page}
          count={totalRecords}
          rowId={(row) => row.id}
          pageCount={totalPages}
          pageSize={rowsPerPage}
          handleChange={(newPage, size) => handleChange(newPage, size)}
        />
      </div>
      {openDeleteTimeSlot && (
        <DeleteTimeSlot
          open={openDeleteTimeSlot}
          handleClose={(data) => {
            setOpenDeleteTimeSlot(data);
            setDiaLogBoxBlur(false);
          }}
          delete={() => setDel(true)}
          DeleteId={timeSlotId}
          name={timeSlotName}
        />
      )}
    </>
  );
};
